import * as THREE from 'three';
import { tolerances } from './constants';
import { UUID } from './typeDefinitions';

// Get Euler angles for rotating vector `from` to vector `to`
export const getEulerAngles = (from: THREE.Vector3, to: THREE.Vector3, axis: THREE.Vector3 | undefined) : THREE.Euler  => {
    
    if (from.length() != 1.0 || to.length() != 1.0 || (axis && axis.length() != 1.0))
        throw new Error("Input vectors must be normalized.");

    // 1. Calculate the angle and axis of rotation
    const angle = from.angleTo(to);
    const cAxis = new THREE.Vector3().crossVectors(from, to).normalize();

    // If the axis is zero, the vectors are parallel and no rotation is needed
    if (cAxis.length() === 0)
        return new THREE.Euler(0,0,0);

    // If axis is not provided, use calculated axis
    if (axis === undefined)
        axis = cAxis;
    // Else check if the provided axis is close enough to the calculated axis
    else if (    Math.abs(cAxis.x - axis.x) > tolerances.direction || 
                Math.abs(cAxis.y - axis.y) > tolerances.direction || 
                Math.abs(cAxis.z - axis.z) > tolerances.direction)
    {
        console.warn(`Given axis ${axis} does not match calculated axis ${cAxis.toArray()}. Using calculated axis.`);
        axis = cAxis;
    }
        
    // 2. Create a Quaternion from the axis and angle
    const quaternion = new THREE.Quaternion();
    quaternion.setFromAxisAngle(axis, angle);
  
    // 3. Create an Euler object from the quaternion
    const euler = new THREE.Euler();
    euler.setFromQuaternion(quaternion);
  
    return euler;
  }

// Function to convert string to enum
export const stringToEnum = <T extends Record<string, string>>(enumObject: T, value: string): T[keyof T] | undefined => {
    const values = Object.values(enumObject) as string[];
    return values.includes(value) ? (value as T[keyof T]) : undefined;
  };

// Converts string to URL. Returns null, if input is not an URL
export const tryParseUrl = (input : string | undefined | null) => {
    if (input)
    {
        try {
            return new URL(input)
        }
        catch (_) {}
    }
    return undefined;
}

